export default "__VITE_ASSET__Bz070Sic__"